module.exports = __webpack_public_path__ + "img/290.5a05f0be.jpg";